// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__PepsT","image":"Accordion_image__nrfiz","accordionContent":"Accordion_accordionContent__F3sKD","fadeIn":"Accordion_fadeIn__owvU_"};